import {
  CHANGE_SEARCH_TEXT,
  UPDATE_SEARCH_RESULTS,
  SEARCH_RESULTS_FAILURE,
  SET_SEARCH_LOADING
} from 'store/actions/search'

const initialState = {
  loading: true,
  text: '',
  results: [],
  count: null
}

const searchReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case CHANGE_SEARCH_TEXT:
      const { text } = payload
      return {
        ...state,
        text
      }
    case SET_SEARCH_LOADING:
      return {
        ...state,
        loading: true
      }
    case UPDATE_SEARCH_RESULTS:
      const { results, count } = payload
      return {
        ...state,
        loading: false,
        results,
        count
      }
    case SEARCH_RESULTS_FAILURE:
      return {
        ...state,
        loading: false,
        results: []
      }
    default:
      return state
  }
}

export default searchReducer
